import { forwardRef } from 'react'
import { SnackbarComponent } from '../index'

interface Props {
  text: string
  actionText: string
  operationAction: () => unknown
  close: () => unknown
}

export const OperationalSnackbar = forwardRef(function OperationalSnackbar(
  { text, actionText, operationAction, close }: Props,
  ref,
) {
  const handleClick = () => {
    operationAction()
    close()
  }
  return (
    <SnackbarComponent
      ref={ref}
      text={text}
      button={actionText}
      onClick={handleClick}
    />
  )
})

OperationalSnackbar.defaultProps = {}
